import { PaginationMeta } from './pagination';

export enum CalendarPartner {
  GOOGLE = 'google',
  OUTLOOK = 'outlook',
}

export const CALENDAR_PARTNERS = Object.values(CalendarPartner);

export type Integration = {
  uuid: string;
  partner: CalendarPartner;
  enabled: boolean;
  settings: {
    calendar_id?: string;
    calendar_name?: string;
    calendar_event_id?: string;
    [key: string]: any;
  };
};

export interface IntegrationResponse {
  data: Integration[];
  meta: PaginationMeta;
}

export interface IntegrationProps {
  integration: Integration | null;
  setIntegration: (integration: Integration | null) => void;
}
